import { useCallback } from 'react';
import { DataListItem, HeaderListItem } from '../types';
import { ROW_TYPES } from '../tableConfigs';
import { useTenants } from 'TenantModule/hooks/useTenants';
import { serializeId } from 'utils';

export const useTenantListItemsBuilder = ({ tenantIds }: { tenantIds: number[] }) => {
  const { getTenant, defaultTenant } = useTenants();

  const listItemBuilder = useCallback(() =>
    //   {
    //   sortBy,
    //   sortDirection,
    // }: {
    //   sortBy: string;
    //   sortDirection: SortDirection;
    // }
    {
      const headerListItem = {
        id: ROW_TYPES.HEADER,
        rowType: ROW_TYPES.HEADER,
        disableRowHover: false,
        isStickyHeader: true,
        // Keep top sticky header only; no sticky left columns to match Sandboxes table
      } as HeaderListItem;
      const formattedTenants = tenantIds.flatMap((tenantId) => getTenant({ tenantId }) || []);

      const sortedTenantListItems: DataListItem[] = formattedTenants.map((tenant) => {
        return {
          id: serializeId([tenant.id]),
          rowType: ROW_TYPES.DATA,
          tenant,
          hideSelectBox: tenant.tenantName === defaultTenant?.tenantName,
          // No sticky left columns for body cells — matches Sandboxes table body styling
        };
      });

      return [headerListItem, ...sortedTenantListItems];
    }, [defaultTenant?.tenantName, getTenant, tenantIds]);

  return listItemBuilder;
};
